import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import zhTW from './zh-TW.json'
import en from './en.json'

/** Shared across lobby + game Mini Apps. */
export const LANG_STORAGE_KEY = 'tg_game_lang'

function detectLanguage(): string {
  try {
    const stored = localStorage.getItem(LANG_STORAGE_KEY)
    if (stored === 'en' || stored === 'zh-TW') return stored
  } catch {
    /* ignore */
  }
  const nav = (typeof navigator !== 'undefined' ? navigator.language : '') || ''
  if (nav.toLowerCase().startsWith('en')) return 'en'
  return 'zh-TW'
}

void i18n.use(initReactI18next).init({
  resources: {
    'zh-TW': { translation: zhTW },
    en: { translation: en },
  },
  lng: detectLanguage(),
  fallbackLng: 'zh-TW',
  supportedLngs: ['zh-TW', 'en'],
  interpolation: { escapeValue: false },
})

i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem(LANG_STORAGE_KEY, lng.startsWith('en') ? 'en' : 'zh-TW')
  } catch {
    /* ignore */
  }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng.startsWith('en') ? 'en' : 'zh-Hant'
  }
})

if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.language?.startsWith('en') ? 'en' : 'zh-Hant'
}

export default i18n
